<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'image-quote-fi': true,
        'image-quote-fi--dark': fields?.dark?.value,
      }"
    >
      <div class="fi-col-start-1 fi-col-end-13 sm:fi-col-start-2 sm:fi-col-end-12">
        <div class="image-quote-fi__container">
          <div class="image-quote-fi__image">
            <ssr-cloud-image-fi
              v-if="isEditMode || fields?.image?.value"
              field-name="image"
              :breakpoints="breakpoints"
              unlimited="773"
              class="image-quote-fi__img"
            />
          </div>
          <quote-fi
            class="image-quote-fi__quote"
            :fields="fields"
          />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { SsrCloudImageFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import QuoteFi from '@/components/quote-fi/QuoteFi.vue';
import type { ImageQuoteFiFields } from '@/generated/fields';

defineOptions({
  name: 'ImageQuoteFi',
});

withDefaults(
  defineProps<{
    fields?: ImageQuoteFiFields | null;
  }>(),
  {
    fields: null,
  },
);

const breakpoints = [
  { mediaWidth: 480, imageWidth: 222 },
  { mediaWidth: 767, imageWidth: 366 },
  { mediaWidth: 1023, imageWidth: 640 },
  { mediaWidth: 1500, imageWidth: 598 },
];
</script>

<style scoped src="./image-quote-fi" />
